import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InitialsAvatar } from './InitialsAvatar';

interface PersonChipProps {
  id?: string;
  name: string;
  relationship?: string;
  avatarUrl?: string;
}

export const PersonChip: React.FC<PersonChipProps> = ({ id, name, relationship, avatarUrl }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (id) {
      navigate(`/community/detail/${id}`);
    }
  };

  return (
    <div 
      className={`inline-flex items-center gap-2 bg-white border border-gray-300 rounded-2xl pl-[1px] pr-3.5 py-[1px] text-sm text-gray-700 transition-colors hover:bg-gray-50 hover:border-gray-400 ${id ? 'cursor-pointer' : 'cursor-default'}`}
      onClick={handleClick}
      role={id ? 'button' : undefined}
      tabIndex={id ? 0 : undefined}
      onKeyDown={id ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      } : undefined}
    >
      <InitialsAvatar personId={id} name={name} avatarUrl={avatarUrl} size={26} />
      <span className="leading-tight">{name}</span>
      {relationship && (
        <span className="text-xs text-gray-500">({relationship})</span>
      )}
    </div>
  );
};
